export const sum = (x, y) => x + y
